import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "../components/Home";
import Header from "../common/Header";
import Footer from "../common/Footer";
import TermCondition from "../components/TermCondition";
import PrivacyPolicy from "../components/PrivacyPolicy";
import AccountDeletion from "../components/AccountDeletion";
import Profile from "../components/Profile";
import ContactUs from "../components/ContactUs";
import Faqs from "../components/Faqs";
import CookiesPolicy from "../components/CookiesPolicy";

const Routing = () => {
  return (
    <>
      <Header />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Routes>
          <Route path="/term-condition" element={<TermCondition />} />
        </Routes>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Routes>
          <Route path="/account-deletion" element={<AccountDeletion />} />
        </Routes>
        <Routes>
          <Route path="/join-us" element={<Profile />} />
        </Routes>
        <Routes>
          <Route path="/contact-us" element={<ContactUs />} />
        </Routes>
        <Routes>
          <Route path="/faqs" element={<Faqs />} />
        </Routes>
        <Routes>
          <Route path="/cookies-policy" element={<CookiesPolicy />} />
        </Routes>
      <Footer />
    </>
  );
};
export default Routing;
